const TeamStrategy = () => {
  return (
    <>
      <p>
        When it comes to Setback, one of the most important aspects of the game
        to master is knowing what to bid based on a variety of variables. As you
        gain more experience, you'll start to develop a better understanding of
        when to pass or bid, and if you do bid, how much. These decisions will
        be heavily influenced by the following:
      </p>
      <ul style={{ marginLeft: "50px", marginTop: "20px" }}>
        <li>The current score</li>
        <li>Strength of your hand, based on statistics and gut instinct</li>
        <li>Your bidding position relative to the other players</li>
      </ul>
    </>
  );
};
export default TeamStrategy;





